import { useQuery, useQueryClient } from '@tanstack/react-query';
import { CompanyBranchViewModel } from '@lib/api-interface';
import { ResourceQueryService } from '@lib/common-sdk';

export const useCompanyBranchView = (branchId: string) => {
  const queryKey = ['companyBranchViews', branchId];
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: queryKey,
    queryFn: (context) => {
      return ResourceQueryService.findOneByField<CompanyBranchViewModel>('/api/resource/companyBranchViews', 'branchId', branchId);
    },
    staleTime: 5000,
  });

  const invalidateQuery = async () => {
    await queryClient.invalidateQueries({ queryKey: queryKey });
  };

  return [query, invalidateQuery] as const;
};
